import React from 'react';

import ForgotPasswordForm from '../components/auth/ForgotPassword/ForgotPasswordForm';

const ForgotPassword = () => {
  return <ForgotPasswordForm />;
};

export default ForgotPassword;
